import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The Vriti wordmark for the dashboard chrome. Both versions are rendered and
 * index.css shows the one that suits the dashboard theme: the light version
 * (white letters) on the dark theme, the navy one under `.vdash-light`.
 */
export default function Wordmark({ height = 24, className = '', }) {
    const width = Math.round((height * 276) / 112);
    return (_jsxs("span", { className: `dash-wordmark relative inline-block flex-shrink-0 ${className}`, style: { height, width }, children: [_jsx("img", { src: '/vriti-wordmark-light.png', alt: 'Vriti', width: width, height: height, className: 'dash-wordmark__light absolute inset-0 w-full h-full object-contain' }), _jsx("img", { src: '/vriti-wordmark.png', alt: 'Vriti', width: width, height: height, className: 'dash-wordmark__dark absolute inset-0 w-full h-full object-contain' })] }));
}
